import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useRanksStore } from "@/stores";

export function useLevelNamer() {
  const { t, te } = useI18n();
  const { categoryRanks } = storeToRefs(useRanksStore());

  function getMainLevelName(level: number): string {
    const titleKey = `main_level_titles.${level}`;
    const adjectiveKey = `level_adjectives.${level}`;

    const title = te(titleKey) ? t(titleKey) : t("main_level_titles.1");

    if (te(adjectiveKey)) {
      const adjective = t(adjectiveKey);
      return `${adjective} ${title}`;
    }

    return title;
  }

  function getCategoryRankName(
    level: number,
    categoryId: string,
    categoryName: string = "Unknown category"
  ): string {
    const categoryRank = categoryRanks.value.find(
      (c) => c.categoryId === categoryId && c.level === level
    );
    if (!categoryRank) {
      console.warn("Category not found for ID:", categoryId);
      return `Level ${level}: ${categoryName}`;
    }
    return categoryRank.levelName || `Level ${level}: ${categoryName}`;
  }

  return {
    getMainLevelName,
    getCategoryRankName,
  };
}
